 <template>
  <div class="app-pegeout">
    <div>
      <nav
        class="navbar navbar-light navbar-expand-lg p-0 border-0 shadow"
        style="background: #E6E6E6;height:50px"
      >
        <div class="container">
          <a href class="navbar-brand router-link-active">
            <img :src="peu" width="40px" alt />
            <span>
              <img :src="peulogo" width="90px" alt />
            </span>
          </a>
          <div class="mobilecitreonnav">
            <ul class="nav navbar-nav ml-md-auto text-uppercase">
              <li class="nav-item peulink">
                <a
                  href="https://www.peugeot.com.gh/homepage.html"
                  class="nav-link download-link"
                  target="_blank"
                  style="color: #505050 !important; "
                >
                  EXPLORE PEUGEOT GHANA
                  <i class="el-icon-arrow-right" style></i>
                </a>
              </li>
            </ul>
          </div>
          <div
            id="navbarSupportedContent"
            class="collapse navbar-collapse container-fluid d-none d-lg-block"
          >
            <ul class="nav navbar-nav ml-md-auto text-uppercase">
              <li class="nav-item py-md-3 peulink">
                <a
                  href="https://www.peugeot.com.gh/homepage.html"
                  class="nav-link download-link"
                  target="_blank"
                  style="color: #505050 !important; "
                >
                  EXPLORE PEUGEOT GHANA
                  <i class="el-icon-arrow-right" style></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
    <section class="peuslider">
      <el-carousel :interval="5000" arrow="never">
        <el-carousel-item v-for="item in 1" :key="item">
          <div class="container">
            <div class="row">
              <div class="sliderinfo">
                <h5>The All-New Peugeot SUV range has the car for any type of driver.</h5>
                <h2>
                  PEUGEOT SUV
                  <span>Range</span>
                </h2>
                <p>From the dynamic New PEUGEOT 2008, to the award-winning PEUGEOT 3008, and the All-New 7-Seat PEUGEOT 5008.</p>
                <div style="margin-top:15%">
                  <el-button
                    type="info"
                    style="border: 1.5px solid #BCBCBC;background:transparent"
                    @click="contact"
                  >
                    BOOK AN APPOINTMENT
                    <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                  </el-button>
                  <!-- <el-button class="text" type="text" @click="pegeout">DISCOVER PEUGEOT</el-button> -->
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- awards -->
    <div class="carinfo_awards" id="model">
      <div class>
        <div class="">
          <div class="container">
            <div class="row py-5">
              <h3 class="newhead" style="line-height: 70px;font-size: 50px;">
                Embrace,
                <br />Evolution & Inspiration
              </h3>
              <p
                style="padding-top:1rem"
              >A brand consists of much more than just its products, it needs to create unique experiences. At Peugeot we develop every stage of the consumers global experience which together enhance the values, identity and image of the brand. Our multi skilled and enormously experienced team is here to help you realize your brands full potential.</p>
            </div>
          </div>
        </div>
        <div class="py-3 d-none d-md-block" style="margin-bottom:1rem">
          <div class="" style="max-width: 1368px;margin-left: 10%;">
            <div class="row pb-4">
              <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="box" style="height: 60%;width: 80%;">
                  <img
                    :src="feature1"
                    width="100%"
                    height="100%"
                    style="max-width: 580px;object-position: 100% 50%;"
                  />
                </div>
                <div class="boxcontent1" style="width:80%">
                  <h6
                    class="py-3"
                    style="font-size:24px;  line-height:26px;text-transform:capitalize"
                  >Live Bigger</h6>
                  <p
                    style="color:#999;font-size:15px;line-height:24px"
                  >The new Peugeot Landtrek offers record capacity of the body, the advanced modularity, the comfort worthy of a saloon car and its strong design makes it functional and enduring.</p>
                </div>
              </div>

              <div class="col-sm-12 col-md-6 col-lg-6" style="padding-right: 0;">
                <div class="box" style="height:80%">
                  <img
                    :src="feature2"
                    width="100%"
                    height="100%"
                    style="object-position: 100% 50%;"
                  />
                </div>
                <div class="boxcontent1" style="width:80%">
                  <h6
                    class="py-3"
                    style="font-size:24px;  line-height:26px;text-transform:capitalize"
                  >Enter A New And Instinctive Dimension</h6>
                  <p
                    style="color:#999;font-size:15px;line-height:24px"
                  >With its distinctive style and innovative materials, PEUGEOT presents its intense and exciting vision of the recreational SUV vehicles.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container">
          <div
            class
            style="border-bottom:0.5px solid rgba(118, 111, 111, 0.3);border-top:0.5px solid rgba(118, 111, 111, 0.3);"
          >
            <div class="py-3">
              <h3 class="model_title" style="font-size: 16px;">
                OUR LATEST
                <span>MODELS</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="py-5" style="margin:2rem 0rem">
          <div class="container">
            <div class>
              <div style="display:flex">
                <div class="carline"></div>

                <div class="row">
                  <div class="col-sm-6 col-md-12 col-lg-12" style="margin:0rem 2rem;">
                    <h5 class="carname text-uppercase">PASSENGER VEHICLES</h5>
                    <div class="row">
                      <div
                        class="text-center py-3"
                        v-for="(promocars, i) in homecars"
                        :key="i"
                        style="margin-right:1rem"
                      >
                        <router-link
                          class="carroute"
                          :to="'/peugeotdetails/' + promocars.name + '/' + promocars.mask"
                        >
                          <img
                            :src="promocars.image"
                            class="img-fluid"
                            alt
                            width="200px"
                            style="background:#FAFAFA"
                            height="112px"
                          />
                          <!-- <div class="brand"><p class="brandname">C-Class Coupé</p></div> -->
                          <div class="brand">
                            <p class="brandname" style="text-transform:uppercase">{{promocars.name}}</p>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="py-3" style="margin:2rem 0rem">
      <div class="container">
        <div class>
          <div style="display:flex">
            <div class="carline"></div>

            <div class="row">
              <div class="col-sm-6 col-md-12 col-lg-12" style="margin:0rem 2rem;">
                <h5 class="carname text-uppercase">COMMERCIAL VEHICLES</h5>
                <div class="row">
                  <div
                    class="text-center py-3"
                        v-for="(promocars, i) in comcars"
                        :key="i"
                        style="margin-right:1rem"
                   
                  >
                    <router-link
                      class="carroute"
                      :to="'/peugeotcomdetails/' + promocars.name + '/' + promocars.mask"
                    >
                      <img
                        :src="promocars.image"
                        class="img-fluid"
                        alt
                        width="200px"
                        style="background:#FAFAFA"
                        height="112px"
                      />
                      <!-- <div class="brand"><p class="brandname">C-Class Coupé</p></div> -->
                      <div class="brand">
                        <p class="brandname" style="text-transform: uppercase;">{{promocars.name}}</p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- play video -->
    <div class="py-4 " style="background:#E3E3E3" id="explore">
      <div class="container">
        <div class="text-center py-4">
          <h3
            class="discover_titles"
          >DISCOVER OUR PEUGEOT SHOWROOM WITH A WIDE RANGE OF VEHICLES TO MEET YOUR AUTOMOBILE NEEDS.</h3>
        </div>
      </div>
    </div>
    <div class>
      <!-- <div class="caroverlay">
        
      </div>-->
      <div class="wrapper " style="width:100%">
        <!-- <img :src="caroverlay" alt /> -->
        <iframe
          width="100%"
          height="560"
          src="https://mpembed.com/show/?m=NAoFnPyNpBP&mpu=532"
          frameborder="0"
          allowfullscreen
          allow="vr"
        ></iframe>
        <!-- <div class="overlay"></div> -->
      </div>
      <!-- <div class="container">
      <div class="carinfo d-none d-md-block">-->
      <!-- <i class="el-icon-video-play" style="font-size:80px;font-weight:300;float:right"></i> -->
      <!-- <img :src="play" alt width="90px" style="float:right" /> -->
      <!-- <div  >
            <h6>Discover</h6>
      <h3>Motion & emotion</h3>-->
      <!-- <el-button type="info" @click="opensite" style="border: 0.5px solid #fff;background:transparent"> -->
      <!-- <a href="https://www.peugeot.com.gh/range/find-your-vehicle.html" class="el-button--info carroute" target="_blank" style="color:#fff;border: 0.5px solid #fff;background:transparent; padding:0.58rem">
               EXPLORE MODELS
              <i class="el-icon-arrow-right" style="padding-left:3%"></i>
      </a>-->

      <!-- </el-button> -->
      <!-- </div>
        </div>
      </div>-->
    </div>
    <div class="carinfo_awards d-none d-md-block" id="model">
      <div class>
        <div>
          <div class="container">
            <div class="row py-5">
              <h3 class="newhead" style="line-height: 70px;font-size: 45px;">
                The Time Is Now.
                <br />Experience A Whole New Kind Of Peugeot.
              </h3>
              <p
                style="padding-top:1rem;width:80%"
              >PEUGEOT’s new range means maximum choice & zero compromise. From the fang headlamps on the front to the claw slash indicators on the back, the rulebook’s been torn up. We've won Car of the Year 3 times in 1 decade. So when we say we’re the leaders of the pack, it isn’t just talk. It’s the reality.</p>
            </div>
          </div>
        </div>
        <div class="py-3" style="margin-bottom:1rem">
          <div class="container" style="max-width: 1368px;margin-left: 10%;">
            <div class="row pb-4">
              <carousel
                :per-page="3"
                :autoplay="true"
                :navigate-to="someLocalProperty"
                :scrollPerPage="false"
                :navigationEnabled="false"
                :paginationEnabled="true"
                :mouse-drag="true"
                :loop="true"
                style="width:100%;"
                navigationPrevLabel="<i class='ti-angle-left circlearrow'></i>"
                navigationNextLabel="<i class='ti-angle-right circlearrow'></i>"
              >
                <slide style="margin-left:5%">
                  <div style="height:70%; width:100%">
                    <img class="img-fluid" :src="model4" />
                  </div>
                </slide>

                <slide style="margin-left:3%">
                  <div style="height:70%; width:100%">
                    <img class="img-fluid" :src="model5" />
                  </div>
                </slide>
                <slide style="margin-left:3%">
                  <div style="height:70%; width:100%">
                    <img class="img-fluid" :src="model6" />
                  </div>
                </slide>
                <slide>
                  <div style="height:70%; width:100%;max-width: 700px">
                    <img class="img-fluid" :src="model2" />
                  </div>
                </slide>
                <slide>
                  <div style="height:70%; width:100%;max-width: 700px">
                    <img class="img-fluid" :src="model3" />
                  </div>
                </slide>
                <slide>
                  <div style="height:70%; width:100%;max-width: 700px">
                    <img class="img-fluid" :src="model1" />
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- pegeout cars -->
    <!-- <div class="py-5" id="pegeout">
      <div class="container py-5" style="padding-bottom: 0rem !important;">
        <div class="explore">
          <b-tabs content-class="mt-3" align="center">
            <b-tab title="DRIVING TAKES ON A NEW DIMENSION IN THE ALL-NEW PEUGEOT 3008" active>
              <div class="py-3">
                <div class="exploreimg">
                  <img
                    :src="exploreimg"
                    alt
                    style="object-fit:contain; max-width:100%;max-height:100%;z-index:1"
                  />
                </div>
                <div class="py-3 exploreinfo text-center">
                  <p>
                    Winner of over 65 International awards, including Carbuyer’s Best Medium SUV 2019 and AutoTrader’s 2019 ‘New Car Of The Year’ the sleek PEUGEOT 3008 SUV combines technology with elegance to display strength and character. Enter a technological world and enjoy an amplified driving experience. 
                    
                    
                   </p>

                  <p>
                  The PEUGEOT 3008 SUV has seduced many juries around the world thanks to its dynamic qualities, stylish exterior, equipment, interior design and the innovative PEUGEOT i-Cockpit®. Fall in love with the powerful front of the PEUGEOT 3008 SUV, with its stylish chrome detail and full LED headlightsi adding to the sleek, feline look. Discover the car’s fluid and dynamic lines, further emphasised by a strong shoulder line running the length of this striking SUV. The sharp design continues at the rear, thanks to its Black Diamond roofi and gloss black rear panel incorporating the PEUGEOT signature claw effect LED lighting.
                  </p>
                </div>
           
              </div>
            </b-tab>
           
          </b-tabs>
        </div>
      </div>
    </div>-->

    <!-- discover -->
    <!-- <div class="py-4" style="background:rgba(235, 233, 222,0.6)">
      <div class="container">
        <div class="text-center py-4">
          <h3 class="discover_titles">
            POWER ON : 
            <span class="range">discover the range</span>
          </h3>
        </div>
      </div>
    </div>-->

    <div class="bg-grey" style="padding-top:3rem">
      <div class="container">
        <core></core>
      </div>
    </div>
  </div>
</template>
<noscript>												
  <p style="margin:0;padding:0;border:0;">												
      <img src="https://a1.adform.net/Serving/TrackPoint/?pm=2867926&ADFPageName=Ghana%20Silverstar%20Peugeot&ADFdivider=|" width="1" height="1" alt="" />												
  </p>												
</noscript>		
<script>
import axios from "axios";
import CoreValues from "../../components/Core.vue";
import { peugeot_cars } from "../../config";
import { peugeot_commercial } from "../../config";
import { Carousel, Slide } from "vue-carousel";
import Tabs from "vue-tabs-with-active-line";
var exploreimg = require("../../assets/img/exploreimg.png");
var feature1 = require("../../assets/img/LANDTREK.jpg");
var feature2 = require("../../assets/img/SUV.jpg");
var feature3 = require("../../assets/img/feature3.png");
var caroverlay = require("../../assets/img/suv.png");
var peu = require("../../assets/img/benz.png");
var model1 = require("../../assets/img/s2.jpg");
var model2 = require("../../assets/img/s4.jpg");
var model3 = require("../../assets/img/s8.jpg");
var model4 = require("../../assets/img/s6.png");
var model5 = require("../../assets/img/s7.jpg");
var model6 = require("../../assets/img/s9.jpg");
var peulogo = require("../../assets/img/peulogo.png");
var play = require("../../assets/img/play.svg");

export default {
  name: " Peugeot",
  components: {
    core: CoreValues,
    Tabs,
    Slide
  },
  data() {
    return {
      exploreimg,
      feature1,
      feature2,
      feature3,
      caroverlay,
      play,
      peu,
      peulogo,
      model1,
      model2,
      model3,
      model4,
      model5,
      model6,
      homecars: peugeot_cars,
      comcars: peugeot_commercial,
      tabs: [
        { title: "Tab 1", value: "tab1" },
        { title: "Tab 2", value: "tab2" },
        { title: "Tab 3", value: "tab3" }
      ],
      currentTab: "tab1"
    };
  },
  metaInfo() {
    return {
      title: " Peugeot"
    };
  },
  computed: {},
  methods: {
    handleClick(newTab) {
      this.currentTab = newTab;
    },
    contact() {
      this.$router.push("/contact");
    },
    opensite() {
      javascript:window.adf&&adf.ClickTrack(this,2867926,'Ghana Silverstar Explore Peugeot Ghana',{});		
      this.window.location.href =
        "https://www.peugeot.com.gh/range/find-your-vehicle.html";
    }
  },
  created() {},mounted(){
    let externalScript = document.createElement('script')
    window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);												
	    window._adftrack.push({												
	        HttpHost: 'a1.adform.net',												
	        pm: 2867926,												
	        divider: encodeURIComponent('|'),												
	        pagename: encodeURIComponent('Ghana Silverstar Peugeot')												
	    });												
	    (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();		
      
      $('a.download-link').click(function(event) {
       
      javascript:window.adf&&adf.ClickTrack(this,2867926,'Ghana Silverstar Download brochure Landtrek',{});	


}



);
      
													
  }
};
</script>
